import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { ApiService } from "../../api/api.service";
import {
  ICreateGenericQuestionReq,
  IGenericQuestion,
  IGetGenericQuestionsReq,
  IGetGenericQuestionsRes,
  IUpdateGenericQuestionReq
} from "../../../_models/generic-questions.model";

@Injectable({
  providedIn: "root",
})
export class GenericQuestionsService {
  constructor(private apiService: ApiService) {}

  getAll(req: IGetGenericQuestionsReq) {
    const params = new HttpParams({
      fromObject: {
        page: String(req.page),
        limit: String(req.limit),
        ...(req.search && { search: req.search }),
        ...(req.includeDeleted != null && { includeDeleted: String(req.includeDeleted) }),
      },
    });

    return this.apiService.get<IGetGenericQuestionsRes>({
      Url: "dating/admin/generic-questions",
      Params: params
    });
  }

  getGroups() {
    return this.apiService.get<string[]>({
      Url: "dating/admin/generic-questions/groups"
    });
  }

  createQuestion(reqData: ICreateGenericQuestionReq) {
    return this.apiService.post<ICreateGenericQuestionReq, IGenericQuestion>({
      Url: "dating/admin/generic-questions",
      Body: reqData
    });
  }

  updateQuestion(reqData: IUpdateGenericQuestionReq) {
    const { id, ...body } = reqData;
    return this.apiService.put<Partial<ICreateGenericQuestionReq>, IGenericQuestion>({
      Url: `dating/admin/generic-questions/${id}`,
      Body: body
    });
  }

  bulkDeleteQuestions(ids: string[]) {
    return this.apiService.post<{ ids: string[] }, any>({
      Url: "dating/admin/generic-questions/bulk-delete",
      Body: { ids }
    });
  }
}
